import { BaseProxy } from '@/proxies/Proxy'

export default class CustomerActivityProxy extends BaseProxy {
  constructor(companyId: string, parameters: Record<string, string | number> = {}) {
    super(parameters)
    this.endpoint = `companies/${companyId}/activity`
  }
}
